import React from 'react';
import './ContentEditor.css';

const ContentEditor = ({ value, onChange, name }) => {
    const insertFormatting = (format) => {
        const textarea = document.querySelector(`textarea[name="${name}"]`);
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const selectedText = value.substring(start, end);
        const beforeText = value.substring(0, start);
        const afterText = value.substring(end);

        let newText = '';
        let cursorPosition = start;

        switch (format) {
            case 'heading':
                if (selectedText) {
                    newText = beforeText + '## ' + selectedText + '\n' + afterText;
                    cursorPosition = start + 3 + selectedText.length + 1;
                } else {
                    newText = beforeText + '## Heading\n' + afterText;
                    cursorPosition = start + 3;
                }
                break;
            case 'bold':
                if (selectedText) {
                    newText = beforeText + '**' + selectedText + '**' + afterText;
                    cursorPosition = start + 2 + selectedText.length + 2;
                } else {
                    newText = beforeText + '**bold text**' + afterText;
                    cursorPosition = start + 2;
                }
                break;
            case 'bullet':
                if (selectedText) {
                    const lines = selectedText.split('\n');
                    const bulletedLines = lines.map(line => `- ${line}`).join('\n');
                    newText = beforeText + bulletedLines + afterText;
                    cursorPosition = start + bulletedLines.length;
                } else {
                    newText = beforeText + '- Bullet point\n' + afterText;
                    cursorPosition = start + 2;
                }
                break;
            default:
                newText = value;
        }

        onChange({ target: { name, value: newText } });

        // Set cursor position after state update
        setTimeout(() => {
            textarea.focus();
            textarea.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    return (
        <div className="content-editor">
            <div className="editor-toolbar">
                <button
                    type="button"
                    className="editor-btn"
                    onClick={() => insertFormatting('heading')}
                    title="Add Heading (##)"
                >
                    <span className="btn-icon">H</span>
                </button>
                <button
                    type="button"
                    className="editor-btn"
                    onClick={() => insertFormatting('bold')}
                    title="Bold Text (**text**)"
                >
                    <span className="btn-icon bold">B</span>
                </button>
                <button
                    type="button"
                    className="editor-btn"
                    onClick={() => insertFormatting('bullet')}
                    title="Bullet List (-)"
                >
                    <span className="btn-icon">•</span>
                </button>
            </div>
            <textarea
                name={name}
                value={value}
                onChange={onChange}
                className="editor-textarea"
                placeholder="Write your blog content here... Use ## for headings&#10;Use **text** for bold&#10;Use - for bullet points Example:&#10;## Introduction&#10;This is a paragraph. ## Key Points&#10;- First point&#10;- Second point&#10;- Third point"
                rows={15}
            />
            <div className="editor-help">
                Use ## for headings, **text** for bold, - for bullet points
            </div>
        </div>
    );
};

export default ContentEditor;

